import { useEffect, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export const CameraScanner = ({ open, onClose, onCode }) => {
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!open) return;
    let scanner;
    const t = setTimeout(async () => {
      try {
        scanner = new Html5Qrcode("cam-reader");
        await scanner.start({ facingMode: "environment" }, { fps: 10, qrbox: { width: 260, height: 140 } }, (text) => {
          onCode(text);
          onClose();
        });
      } catch (e) {
        setErr("Camera not available on this device or permission denied.");
      }
    }, 200);
    return () => {
      clearTimeout(t);
      if (scanner?.isScanning) scanner.stop().catch(() => {});
    };
  }, [open, onClose, onCode]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="camera-scanner-dialog">
        <DialogHeader><DialogTitle>Scan with camera</DialogTitle></DialogHeader>
        <div id="cam-reader" className="w-full min-h-[240px] rounded-lg overflow-hidden bg-slate-900" />
        {err && <p className="text-sm text-red-600" data-testid="camera-error">{err}</p>}
      </DialogContent>
    </Dialog>
  );
};
